import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import Link from 'shared/SlashLink';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 2,
        title: 'Affordable Housing',
        link: '/affordable-housing',
    },
    {
        id: 3,
        title: 'Company',
        link: '/about',
        submenu: [
            { id: 31, title: 'About Us', link: '/about' },
            { id: 32, title: 'Our Pricing', link: '/pricing' },
            { id: 33, title: 'AI Business Integration', link: '/service-single/AI-Business-Integration' },
        ]
    },
    {
        id: 4,
        title: 'Service',
        link: '/service',
    },
    {
        id: 5,
        title: 'Portfolio',
        link: '/portfolio',
    },
    {
        id: 6,
        title: 'Blog',
        link: '/blog',
    },
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    },
    {
        id: 89,
        title: 'Client Login',
        link: '/portal/login',
    }


]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="subMenu">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</Link>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <Link className="active"
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;